import React from "react";
import { CustomerRef } from "@graphql";
import { ChevronRight } from "@material-ui/icons";
import { PlainLink } from "./typography/PlainLink";

type Props = {
  parents: CustomerRef[];
  onClick: (e: React.SyntheticEvent<any>, id: string) => void;
  afterLabel?: React.ReactNode;
};

const CustomerParents: React.FC<Props> = (props) => {
  const { onClick, parents } = props;

  if (!props.parents.length) {
    return null;
  }

  return (
    <div>
      {parents.map((parent, i) => (
        <PlainLink
          key={parent.Id}
          inline
          onClick={(e) => {
            onClick && onClick(e, parent.Id);
          }}
          variant="subtitle1"
          data-test="Breadcrumb"
        >
          {parent.Name}
          {i < parents.length - 1 && <ChevronRight />}
        </PlainLink>
      ))}
      {props.afterLabel}
    </div>
  );
};

export default CustomerParents;
